<!--<table style="    margin-right: 0px;-->
<!--    text-align: right;-->
<!--    float: right;">-->

<!--    <tr>-->
<div class="d-flex">
        <div style="vertical-align: top;" class="d-none d-sm-block">
            <div  *ngIf="product">
                <app-thumbnail-images [product]="product"></app-thumbnail-images>
            </div>

        </div>
        <div>

            <div  *ngIf="product">
                <app-main-image [product]="product"></app-main-image>

            </div>

        </div>
</div>

<!--    </tr>-->

<!--</table>-->



